<template>
  <div id="app">
    <v-app id="inspire">
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-container grid-list-xl>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation>
            <v-layout
                class="mt-3"
                row
                align-end
                justify-space-between
            >
                <v-flex xs12 sm12 md5>
                     <v-text-field v-model="ncm" label="Código NCM"  :rules="tamanhoRules"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md5>
                    <v-combobox
                        v-model="tributo"
                        :items="tipoTributo"
                        label="Tributos"
                        hide-no-data
                        deletable-chips
                        hide-selected
                        item-text="nome"
                        item-value="id"
                        placeholder="Comece a digitar para procurar"
                        multiple
                        chips
                        :loading= "loadingTributos"
                        :search-input.sync="searchTributos"
                    >
                    </v-combobox>
                </v-flex>
            </v-layout>
        </v-form>
        <v-layout
            class="mt-4"
            row
            align-end
        >
            <v-btn
            class="ml-2"
            color="success"
            @click="criarNcm"
            >
            Salvar
            </v-btn>

            <v-btn
            color="error"
            @click="reset"
            >
            Cancelar
            </v-btn>

            <v-btn
            color="warning"
            @click="back"
            >
            Voltar
            </v-btn>
        </v-layout>
        <v-layout
            class="mt-4">
            <v-flex xs12 md12>
                <v-textarea
                    v-if="this.envio !== ''"
                    disabled
                    outline
                    no-resize
                    rows = "5"
                    name="inputEnvio"
                    label="Envio"
                    :value="this.envio"
                ></v-textarea>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 md12>
                <v-textarea
                    v-if="this.mostrar !== ''"
                    disabled
                    outline
                    no-resize
                    rows = "5"
                    name="inputMostrar"
                    label="Resposta"
                    :value="this.mostrar"
                ></v-textarea>
            </v-flex>
        </v-layout>
      </v-container>
    </v-app>
  </div>
</template>

<script>
    import {sharedService} from '../services'

    export default {
        name: 'NcmForm',
        data() {
            return {
                searchTributos: '',
                loadingTributos: false,
                editedIndex: -1,
                ncm: '',
                tributo: '',
                mostrar: '',
                envio: '',
                newNcm:{
                    ncm_id: '',
                    tributos: []
                },
                tipoTributo:[],
                valid: true,
                text: '',
                obrigatorioRules: [
                    v => !!v || 'Este campo é obrigatório'
                ],
                tamanhoRules: [
                    v => !!v || 'Este campo é obrigatório'
                ]
            }
        },
        created () {
            if (this.$route.params.id) {
                this.id = this.$route.params.id
                this.editedIndex = 1
                this.getData()
            } else {
                this.editedIndex = -1
            }
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Novo NCM' : 'Edita NCM'
            }
        },
        methods: {
            criarNcm() {
                let self = this
                if(this.editedIndex === -1){
                    this.$confirm('Tem certeza que deseja salvar este item?').then(res => {
                        if (res) {
                            if (this.$refs.form.validate()) {
                                for (var key in self.tributo) {
                                    self.newNcm.tributos[key] = self.tributo[key].id
                                }
                                self.newNcm.ncm_id = self.ncm
                                sharedService.create('NCMEmpresa', this.newNcm).then(function (obj){
                                    self.envio = JSON.stringify(self.newNcm)
                                    obj.text().then(function (text){
                                        self.mostrar = text
                                        if(obj.status === 200){
                                            self.$store.dispatch('success', 'NCM cadastrada com sucesso!')
                                        }  else {
                                            self.$store.dispatch('error', text)
                                        }
                                    })
                                })
                            } else {
                                alert('Preencha os campos obrigatórios!')
                            }
                        } else {
                            this.close()
                        }
                    })
                } else {
                        this.$confirm('Tem certeza que deseja editar este item?').then(res => {
                        if (res) {
                            if (this.$refs.form.validate()) {
                                for (var key in self.tributo) {
                                    self.newNcm.tributos[key] = self.tributo[key].id
                                }
                                sharedService.update('NCMEmpresa', this.newNcm, this.id).then(function (obj){
                                    self.envio = JSON.stringify(self.newNcm)
                                    obj.text().then(function (text){
                                        self.mostrar = text
                                        if(obj.status === 200){
                                            self.$store.dispatch('success', 'NCM editada com sucesso!')
                                        }  else {
                                            self.$store.dispatch('error', text)
                                        }
                                    })
                                })
                            } else {
                                alert('Preencha os campos obrigatórios!')
                            }
                        } else {
                            this.close()
                        }
                    })
                }
            },
            back () {
                this.$router.push({
                name: 'Ncm'
                })  
            },
            reset () {
                this.$refs.form.reset()
            },
            getData: async function () {
                let self = this
                await sharedService.read('NCMEmpresa',{limit: 1}, this.id).then(function (obj){
                    self.ncm = obj.ncm_id.nome
                    self.tributo = obj.tributos
                    self.newNcm.ncm_id = obj.ncm_id
                })
            }
        }, 
        watch: {
            searchTributos (val) {
                let self = this
                this.loadingTributos = true

                let busca
                if(val === null || val === ''){
                    busca = 'limit=10'
                } else {
                    busca = 'filtros=[["nome","like","'+val+'%"]]'
                }

                sharedService.read('Tributos?'+busca).then(function (obj){
                    self.tipoTributo = []
                    for (var key in obj.obj) {
                        let obje = {
                            id: obj.obj[key].id,
                            nome: obj.obj[key].nome
                        }
                        self.tipoTributo.push(obje)
                    }
                    self.loadingTributos = false
                })
            }
        }
    }
</script>

<style>

</style>
